// extracted by mini-css-extract-plugin
export default {"featureCardGroup":"OrderList_featureCardGroup__L4VfF","refunded":"OrderList_refunded__ofbMt","badge":"OrderList_badge__5FH7L"};